import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/Auth/otp.css";
import Button from "../../components/ui/Button/Button";
import AuthCard from "../../components/ui/Cards/AuthCard";
import LogoCards from "../../components/ui/Cards/LogoCards";
import logo from "../../assets/images/logo1.png";
import logo1 from "../../assets/images/Frame 35.png";
import logo2 from "../../assets/images/Frame 47.png";
import logo3 from "../../assets/images/Frame 35.png";
import logo4 from "../../assets/images/logo7.png";
import LogoBottom from "../../assets/images/shreepuram_vijay_prateek.png";
import logo5 from "../../assets/images/logo4.png";
import { FaArrowRightToBracket } from "react-icons/fa6";
import { toast } from "react-toastify";

const OTP_EXPIRY_SECONDS = 60;
const OTP_TIME_KEY = "otp_sent_time";

const ForgotOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  // const [timer, setTimer] = useState(60);
  // const [resendDisabled, setResendDisabled] = useState(true);

  ////////////////////
  const [timer, setTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(true);
  // //////////////

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;

  // TIMER FROM localStorage
  useEffect(() => {
    const sentTime = localStorage.getItem(OTP_TIME_KEY);

    if (!sentTime) {
      setResendDisabled(false);
      return;
    }

    const elapsed = Math.floor((Date.now() - Number(sentTime)) / 1000);
    const remaining = OTP_EXPIRY_SECONDS - elapsed;

    if (remaining > 0) {
      setTimer(remaining);
      setResendDisabled(true);
    } else {
      setTimer(0);
      setResendDisabled(false);
    }
  }, []);

  // ⏱ Countdown Timer (LOGIC UNCHANGED)
  // useEffect(() => {
  //   if (timer > 0) {
  //     const interval = setInterval(() => setTimer(t => t - 1), 1000);
  //     return () => clearInterval(interval);
  //   } else {
  //     setResendDisabled(false);
  //   }
  // }, [timer]);

  useEffect(() => {
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // Handle OTP input

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedOtp = e.clipboardData.getData("Text").slice(0, 6);
    const newOtp = pastedOtp.split("");
    setOtp(newOtp);
  };

  // VERIFY OTP (API UNCHANGED)

  const verifyOtp = async () => {
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) return toast.error("Please enter OTP");
    try {
      const res = await api.post("/auth/forgot-password/verify-otp", {
        phone: phoneNumber,
        otp: enteredOtp,
      });
      if (res.data.verified === true) {
        localStorage.removeItem(OTP_TIME_KEY);
        navigate("/reset-password", { state: { phoneNumber: phoneNumber } });
      }
    } catch (err) {
      toast.error("Invalid OTP");
    }
  };

  // RESEND OTP (API UNCHANGED)

  const resendOtp = async () => {
    try {
      setLoading(true);
      const res = await api.post("/auth/forgot-password/request-otp", {
        phone: phoneNumber,
      });
      localStorage.setItem(OTP_TIME_KEY, Date.now().toString());
      toast.success(`OTP sent to ${phoneNumber}`);
      setTimer(60);
      setResendDisabled(true);
    } catch (err) {
      toast.success(`Failed to resend OTP`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="otp-wrapper">
      {/* LEFT SIDE */}
      <div className="col-6 otp-left01">
        <div className="otp-content01">
          <h2>
            Welcome To{" "}
            <span className="second-line02">
              Bharat Jagriti <sup>™</sup>
            </span>
          </h2>
          <p className="tagline01">EXPLORE THE TRUTH TO THE WORLD</p>
        </div>
        <LogoCards allImg={[logo1, logo2, logo3, logo4, logo5]} />
      </div>

      {/* RIGHT SIDE */}
      <div className="otp-right">
        <div className="right-content">
          <h2 className="right-title">Check Your Phone</h2>
          <p className="right-sub">
            We've sent the code to <b>{phoneNumber}</b>
          </p>

          <div className="otp-box-row">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                className="otp-box"
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleBackspace(e, index)}
                onPaste={handlePaste}
              />
            ))}
          </div>

          <p className="expire-text">
            Code expires in{" "}
            <span>
              {`${Math.floor(timer / 60)
                .toString()
                .padStart(2, "0")}:${(timer % 60).toString().padStart(2, "0")}`}
            </span>
            &nbsp;
            <span
              className="resend"
              onClick={!resendDisabled ? resendOtp : undefined}
              style={{
                color: resendDisabled ? "grey" : "blue",
                cursor: resendDisabled ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Sending..." : "Resend"}
            </span>
          </p>

          <Button
            className={"NextBtn"}
            onClick={verifyOtp}
            icon={FaArrowRightToBracket}
            disabled={loading}
          >
            {loading ? "Please Wait..." : "Verify"}
          </Button>
        </div>

        <div className="forgot_logo_bottom">
          <img src={LogoBottom} alt="powered" />
          <p>Powered by Sripuram</p>
        </div>
      </div>
    </div>
  );
};

export { ForgotOtp };
